import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useAuth } from '../contexts/AuthContext';
import { getActivePromotion } from '../services/api';

// 同 EventRegister.js 果套 DOMPurify 設定一致,加多 <img> 因為呢度係優惠海報,
// 通常會用圖片,唔淨係文字連結。
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const sanitizePromoHtml = (html) =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['a', 'b', 'strong', 'i', 'em', 'u', 'br', 'p', 'ul', 'ol', 'li', 'span', 'img'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'style'],
  });

const shownKey = (merchantSlug, promoId) => `promo_shown_${merchantSlug}_${promoId}`;

const PromoModal = ({ merchantSlug }) => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [promo, setPromo] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!merchantSlug || !isAuthenticated) return;

    let cancelled = false;
    getActivePromotion(merchantSlug)
      .then((res) => {
        if (cancelled) return;
        const data = res.data;
        if (!data) return;
        // 每個優惠(用 id 分)每個 session 淨係彈一次,唔想煩到會員每過一頁都見一次
        if (sessionStorage.getItem(shownKey(merchantSlug, data.id))) return;
        setPromo(data);
        setVisible(true);
        sessionStorage.setItem(shownKey(merchantSlug, data.id), '1');
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantSlug]);

  if (!visible || !promo) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4"
      onClick={() => setVisible(false)}
    >
      <div
        className="relative max-h-[85vh] w-full max-w-sm overflow-y-auto rounded-2xl bg-white p-5 shadow-xl dark:bg-gray-800"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={() => setVisible(false)}
          className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300"
          aria-label="關閉"
        >
          ✕
        </button>
        <div
          className="max-w-none pt-6 text-sm leading-relaxed text-gray-800 dark:text-gray-100 [&_img]:max-w-full [&_img]:rounded-lg [&_p]:mb-2 [&_a]:text-blue-600 [&_a]:underline"
          dangerouslySetInnerHTML={{ __html: sanitizePromoHtml(promo.content_html) }}
        />
        <button
          type="button"
          onClick={() => {
            setVisible(false);
            navigate(`/${merchantSlug}/promo`);
          }}
          className="mt-4 w-full rounded-xl bg-blue-600 py-2.5 font-bold text-white"
        >
          立即查看
        </button>
      </div>
    </div>
  );
};

export default PromoModal;
